<template>
    <div>
        <h1>Места трансфера</h1>
        <transfer-places-list />
    </div>
</template>

<script>
import TransferPlacesList from '@/modules/transfer/components/TransferPlacesList';

export default {
    name: 'TransferPlacesListView',
    components: { TransferPlacesList }
};
</script>
